import { Component, OnInit, ViewChild } from '@angular/core';
import { RebateRequestComponent } from 'src/app/front-user/services/long-haul/rebate-request/rebate-request.component';
import { LongHaulRequestOption, LongHaulRequestFormulateDecision, LongHaulRequestOptionFormulatedDecision, LongHaulRequestReleaseRebateOption, LongHaulRequestReleaseRebate, LongHaulRequestAccurateDataForm } from 'src/app/shared/models/long-haul.model';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { Router } from '@angular/router';
import { User } from 'src/app/front-user/shared/models/user.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { ErrorsEnum } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-change-rebate-form',
  templateUrl: './change-rebate-form.component.html'
})

export class ChangeRebateFormComponent implements OnInit {
  //#region Properties & Variables
  private rebateRequestId: string = "";
  @ViewChild('rebateRequest',{static: false}) rebateRequest: RebateRequestComponent;
  //Options
  public longHaulRequestOptions: LongHaulRequestOption[] = [];
  private getRequestOptionsDetailsRequest: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private getRequestOptionsDetailsRequestResponseObject: ResponseObject = new ResponseObject();
  private getRequestOptionsDetailsResponse: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private releaseRebateOptions: LongHaulRequestReleaseRebateOption[] = [];
  private currentSelctedOption: string = "null";
  private optionSelectedText: string = "";
  private isOptionDetailsSelected: boolean = false;
  private selectedLongHaulRequestOption: LongHaulRequestReleaseRebateOption = new LongHaulRequestReleaseRebateOption();
  //Loading Components
  private rates: GenericLookup[] = [];
  private noOfLoadedComponents: number = 0;
  private noOfComponentsToLoad: number = 1;
  //Form Mode
  private formMode: FormMode = FormMode.New;
  //Option Actions
  private isUpdateRebate: boolean = false;
  private isConfirmRebate: boolean = false;
  private isCancelRebate: boolean = false;
  private isOptionSubmitted: boolean = false;
  //Submit Action
  private longHaulRequestReleaseRebate: LongHaulRequestReleaseRebate = new LongHaulRequestReleaseRebate();
  private longHaulRequestReleaseRebateResponseObject: ResponseObject = new ResponseObject();
  private longHaulRequestReleaseRebateOptionsLength: number = 0;
  private updatedRebatePercentageNotValid: boolean = false;
  private updatedRebatePercentageValueNotValid: boolean = false;
  private cancelationReasonNotValid: boolean = false;
  private isFormSubmitted: boolean = false;
  private isOptionsRebateArrNotValid: boolean = false;
  public isRequestSucceeded: boolean = false;
  //Get Release Rebate
  private getLongHaulRequestReleaseRebate: LongHaulRequestReleaseRebate = new LongHaulRequestReleaseRebate();
  private getLongHaulRequestReleaseRebateResponseObject: ResponseObject = new ResponseObject();
  private getLoadedLongHaulRequestReleaseRebate: LongHaulRequestReleaseRebate = new LongHaulRequestReleaseRebate();
  private releaseRebateMessageNotValid: boolean = false;
  //Accurate Data Form
  private getAccurateDataFormResponseObject: ResponseObject = new ResponseObject();
  private getAccurateDataFormObject: LongHaulRequestAccurateDataForm;
  private isAccurateDataForm: boolean = false;
  private accurateDataFormDateOfSailing: Date;
  //User Properties
  public currentUser: User = new User();
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  //#endregion

  constructor(private lookupService: LookupService,private longHaulService: LongHaulService, private globalServices: GlobalServices, private router: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    this.loadRates();
  }
  loadRates(): void {
    this.lookupService.getRates().subscribe(
      data => this.rates = data.Data as GenericLookup[],
      () => console.log("Something went wrong!!"),
    );
  }
  onRebateRequestLoadedFlag(flag: boolean) {
    if(flag){
      this.rebateRequestId = this.rebateRequest.rebateRequestLoaded.Id;
      this.longHaulRequestOptions = this.rebateRequest.rebateRequestLoaded.LongHaulRequestOptions;
      this.rebateRequest.showOptionDev = false;
      this.rebateRequest.editModeAdmin = true;
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      this.loadComponents();
    }
  }
  loadComponents(): void {
    this.getAccurateDataForm();
    this.getRebateRequestOptions();
  }
  getRebateRequestOptions(): void {
    this.getRequestOptionsDetailsRequest.LongHaulRequestId = this.rebateRequestId;
    for(let i: number = 0; i < this.longHaulRequestOptions.length; i++){
      this.getRequestOptionsDetailsRequest.LongHaulRequestOptionsFormulatedDecision[i] = new LongHaulRequestOptionFormulatedDecision();
      this.getRequestOptionsDetailsRequest.LongHaulRequestOptionsFormulatedDecision[i].Id = this.longHaulRequestOptions[i].Id;
    }
    this.getRebateRequestOptionsDetails();
  }
  getRebateRequestOptionsDetails(): void {
    this.getRequestOptionsDetailsRequest.IsFormulatedDecisionComponent = true;
    this.longHaulService.getRebateRequestToFormulateDecision(this.getRequestOptionsDetailsRequest).subscribe(
      data => this.getRequestOptionsDetailsRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getRebateRequestOptionsDetailsCompleted()
    );
  }
  getRebateRequestOptionsDetailsCompleted(): void {
    if(this.getRequestOptionsDetailsRequestResponseObject.Success) {
      this.getRequestOptionsDetailsResponse = this.getRequestOptionsDetailsRequestResponseObject.Data as LongHaulRequestFormulateDecision;
      for(let i: number = 0; i < this.getRequestOptionsDetailsResponse.LongHaulRequestOptionsFormulatedDecision.length; i++){
        this.releaseRebateOptions[i] = new LongHaulRequestReleaseRebateOption();
        this.releaseRebateOptions[i].Id = this.getRequestOptionsDetailsResponse.LongHaulRequestOptionsFormulatedDecision[i].Id;
        this.releaseRebateOptions[i].LastPortOfOrigin = this.getRequestOptionsDetailsResponse.LongHaulRequestOptionsFormulatedDecision[i].LastPortOfOrigin;
        this.releaseRebateOptions[i].FirstPortOfDestination = this.getRequestOptionsDetailsResponse.LongHaulRequestOptionsFormulatedDecision[i].FirstPortOfDestination;
        this.releaseRebateOptions[i].RebatePercentageNumbers = +this.getRequestOptionsDetailsResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentage;
        this.releaseRebateOptions[i].RebatePercentageLetters = this.getRequestOptionsDetailsResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentage;
      }
      this.getLongHaulRequestReleaseRebate.LongHaulRequestId = this.rebateRequestId;
      this.getLongHaulRequestReleaseRebate.LongHaulRequestReleaseRebateOptions = this.releaseRebateOptions;
      this.getReleaseRebate();
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  setFormMode(): void {
    if(this.getLoadedLongHaulRequestReleaseRebate.IsRebateReleased){
      for(let i: number = 0; i < this.releaseRebateOptions.length; i++){
        this.releaseRebateOptions[i].IsOptionAdminDone = true;
      }
      this.formMode = FormMode.Details;
    } else {
      for(let i: number = 0; i < this.releaseRebateOptions.length; i++){
        this.releaseRebateOptions[i].UpdatedRebatePercentage = undefined;
      }
    }
    const el = document.getElementsByClassName('sectionTitle');
    el[0].scrollIntoView({behavior:'smooth'});
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  onOptionChange(event): void {
    let selectedOptions = event.target['options'];
    let selectedIndex = selectedOptions.selectedIndex;
    this.optionSelectedText = selectedOptions[selectedIndex].text;
    if(this.currentSelctedOption != "null") {
      this.isOptionDetailsSelected = true;
      this.selectedLongHaulRequestOption = this.releaseRebateOptions.filter(o => o.Id == this.currentSelctedOption)[0];
    } else {
      this.isOptionDetailsSelected = false;
      this.selectedLongHaulRequestOption = new LongHaulRequestReleaseRebateOption();
    }
    this.isOptionsRebateArrNotValid = false;
  }
  onOptionChangeRebateDecisionChange(): void {
    if(this.selectedLongHaulRequestOption.DecisionIdString == Decision.Update){
      this.cancelationReasonNotValid = false;
      this.selectedLongHaulRequestOption.CancelationReason = undefined;
    } else if(this.selectedLongHaulRequestOption.DecisionIdString == Decision.Confirm){
      this.updatedRebatePercentageNotValid = false;
      this.cancelationReasonNotValid = false;
      this.selectedLongHaulRequestOption.UpdatedRebatePercentage = undefined;
      this.selectedLongHaulRequestOption.CancelationReason = undefined;
    } else if(this.selectedLongHaulRequestOption.DecisionIdString == Decision.Cancel){
      this.updatedRebatePercentageNotValid = false;
      this.selectedLongHaulRequestOption.UpdatedRebatePercentage = undefined;
    }
  }
  rebatePercentageChange(): void {
    if(this.selectedLongHaulRequestOption.UpdatedRebatePercentage != undefined){
      if(this.selectedLongHaulRequestOption.UpdatedRebatePercentage.toString().length > 0){
        this.updatedRebatePercentageNotValid = false;
        if(+this.selectedLongHaulRequestOption.UpdatedRebatePercentage === this.selectedLongHaulRequestOption.RebatePercentageNumbers)
          this.updatedRebatePercentageValueNotValid = true;
        else
          this.updatedRebatePercentageValueNotValid = false;
      }
      else {
        this.updatedRebatePercentageNotValid = true;
      }
    }
  }
  addOptionRebatePercentageDecision(): void {
    if(this.checkOptionSuvmitValidity()){
      let checkOptionAdded = this.longHaulRequestReleaseRebate.LongHaulRequestReleaseRebateOptions.filter(o => o.Id == this.selectedLongHaulRequestOption.Id)[0];
      if(checkOptionAdded == undefined){
        this.longHaulRequestReleaseRebate.LongHaulRequestReleaseRebateOptions[this.longHaulRequestReleaseRebateOptionsLength] = this.selectedLongHaulRequestOption;
        this.longHaulRequestReleaseRebate.LongHaulRequestReleaseRebateOptions[this.longHaulRequestReleaseRebateOptionsLength].DecisionId = +this.longHaulRequestReleaseRebate.LongHaulRequestReleaseRebateOptions[this.longHaulRequestReleaseRebateOptionsLength].DecisionIdString;
        this.longHaulRequestReleaseRebate.LongHaulRequestReleaseRebateOptions[this.longHaulRequestReleaseRebateOptionsLength].UpdatedRebatePercentage = +this.longHaulRequestReleaseRebate.LongHaulRequestReleaseRebateOptions[this.longHaulRequestReleaseRebateOptionsLength].UpdatedRebatePercentage;
        this.longHaulRequestReleaseRebate.LongHaulRequestReleaseRebateOptions[this.longHaulRequestReleaseRebateOptionsLength].IsOptionAdminDone = true;
        this.longHaulRequestReleaseRebateOptionsLength++;
      } else {
        checkOptionAdded.UpdatedRebatePercentage = +this.selectedLongHaulRequestOption.UpdatedRebatePercentage;
        checkOptionAdded.CancelationReason = this.selectedLongHaulRequestOption.CancelationReason;
      }
      this.isFormSubmitted = true;
      this.isOptionDetailsSelected = false;
      this.currentSelctedOption = "null";
      this.isOptionSubmitted = false;
      this.isOptionsRebateArrNotValid = false;
      const el = document.getElementById('ddlOptions');
      el.scrollIntoView({behavior:'smooth'});
    }
  }
  checkOptionSuvmitValidity(): boolean {
    let isOptionValid: boolean = true;
    if(this.selectedLongHaulRequestOption.DecisionIdString == Decision.Update){
      if(this.selectedLongHaulRequestOption.UpdatedRebatePercentage === undefined || this.selectedLongHaulRequestOption.UpdatedRebatePercentage === null || this.selectedLongHaulRequestOption.UpdatedRebatePercentage.toString().length === 0){
        isOptionValid = false;
        this.updatedRebatePercentageNotValid = true;
      } else if(+this.selectedLongHaulRequestOption.UpdatedRebatePercentage === this.selectedLongHaulRequestOption.RebatePercentageNumbers){
        isOptionValid = false;
        this.updatedRebatePercentageValueNotValid = true;
      }
    } else if(this.selectedLongHaulRequestOption.DecisionIdString == Decision.Cancel){
      if(this.selectedLongHaulRequestOption.CancelationReason === undefined || this.selectedLongHaulRequestOption.CancelationReason === null || this.selectedLongHaulRequestOption.CancelationReason.length === 0){
        isOptionValid = false;
        this.cancelationReasonNotValid = true;
      }
    }
    return isOptionValid;
  }
  submit(): void {
    if(this.releaseRebateOptions.length != this.longHaulRequestReleaseRebate.LongHaulRequestReleaseRebateOptions.length && (this.longHaulRequestReleaseRebate.ReleaseRebateMessage === undefined || this.longHaulRequestReleaseRebate.ReleaseRebateMessage === null || this.longHaulRequestReleaseRebate.ReleaseRebateMessage.length === 0)){
      this.isOptionsRebateArrNotValid = true;
      this.releaseRebateMessageNotValid = true;
    } else if(this.releaseRebateOptions.length != this.longHaulRequestReleaseRebate.LongHaulRequestReleaseRebateOptions.length){
      this.isOptionsRebateArrNotValid = true;
    } else if(this.longHaulRequestReleaseRebate.ReleaseRebateMessage === undefined || this.longHaulRequestReleaseRebate.ReleaseRebateMessage === null || this.longHaulRequestReleaseRebate.ReleaseRebateMessage.length === 0){
      this.releaseRebateMessageNotValid = true;
    } else {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      this.longHaulRequestReleaseRebate.LongHaulRequestId = this.rebateRequestId;
      this.longHaulRequestReleaseRebate.AdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
      this.releaseRebate();
    }
  }
  releaseRebate(): void {
    this.longHaulService.releaseRebate(this.longHaulRequestReleaseRebate).subscribe(
      data => this.longHaulRequestReleaseRebateResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.releaseRebateCompleted()
    );
  }
  releaseRebateCompleted(): void {
    if(!this.longHaulRequestReleaseRebateResponseObject.Success) {
      if(this.longHaulRequestReleaseRebateResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if(this.longHaulRequestReleaseRebateResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    this.isRequestSucceeded = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  getReleaseRebate(){
    this.longHaulService.getReleaseRebate(this.getLongHaulRequestReleaseRebate).subscribe(
      data => this.getLongHaulRequestReleaseRebateResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getReleaseRebateCompleted()
    );
  }
  getReleaseRebateCompleted(): void {
    if(this.getLongHaulRequestReleaseRebateResponseObject.Success) {
      this.getLoadedLongHaulRequestReleaseRebate = this.getLongHaulRequestReleaseRebateResponseObject.Data as LongHaulRequestReleaseRebate;
      if(this.getLoadedLongHaulRequestReleaseRebate.IsRebateReleased){
        this.releaseRebateOptions = this.getLoadedLongHaulRequestReleaseRebate.LongHaulRequestReleaseRebateOptions;
        for(let i: number = 0; i < this.releaseRebateOptions.length; i++){
          if(this.releaseRebateOptions[i].RebatePercentageNumbers == -1)
            this.releaseRebateOptions[i].RebatePercentageLetters = "-";
          else if(this.releaseRebateOptions[i].RebatePercentageNumbers == -2)
            this.releaseRebateOptions[i].RebatePercentageLetters = "--";
          else
            this.releaseRebateOptions[i].RebatePercentageLetters = this.releaseRebateOptions[i].RebatePercentageNumbers.toString();
        }
        this.longHaulRequestReleaseRebate.ReleaseRebateMessage = this.getLoadedLongHaulRequestReleaseRebate.ReleaseRebateMessage;
      }
      this.setFormMode();
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  onReleaseRebateMessageChange(): void {
    if(this.longHaulRequestReleaseRebate.ReleaseRebateMessage === undefined || this.longHaulRequestReleaseRebate.ReleaseRebateMessage === null || this.longHaulRequestReleaseRebate.ReleaseRebateMessage.length === 0){
      this.releaseRebateMessageNotValid = true;
    } else {
      this.releaseRebateMessageNotValid = false;
    }
  }
  onCancelationReasonChange(): void {
    if(this.selectedLongHaulRequestOption.CancelationReason === undefined || this.selectedLongHaulRequestOption.CancelationReason === null || this.selectedLongHaulRequestOption.CancelationReason.length === 0){
      this.cancelationReasonNotValid = true;
    } else {
      this.cancelationReasonNotValid = false;
    }
  }
  later(): void {
    this.router.navigateByUrl('/workspace');
  }
  getAccurateDataForm(): void {
    this.longHaulService.getAccurateDataForm(this.rebateRequestId).subscribe(
      data => this.getAccurateDataFormResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getAccurateDataFormCompleted()
    );
  }
  getAccurateDataFormCompleted(): void {
    if(this.getAccurateDataFormResponseObject.Success) {
      this.getAccurateDataFormObject = this.getAccurateDataFormResponseObject.Data as LongHaulRequestAccurateDataForm;
      if(this.getAccurateDataFormObject != null){
        if(this.getAccurateDataFormObject.DateOfSailing != null || this.getAccurateDataFormObject.PortOfOrigin != "" || this.getAccurateDataFormObject.PortOfDestination != "" || this.getAccurateDataFormObject.SCNT != "" || this.getAccurateDataFormObject.VesselTypeId != null || this.getAccurateDataFormObject.Cargo != "" || this.getAccurateDataFormObject.OtherCharges != "" || this.getAccurateDataFormObject.Deadweight != "" || this.getAccurateDataFormObject.NoOfEscTugs != null || this.getAccurateDataFormObject.NoOfImposedTugs != null || this.getAccurateDataFormObject.Remarks != ""){
          this.accurateDataFormDateOfSailing = this.getAccurateDataFormObject.DateOfSailing != null ? new Date(this.getAccurateDataFormObject.DateOfSailing) : null;
          this.isAccurateDataForm = true;
        }
      }
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
}

enum FormMode {
  New = 1,
  Details = 2
}

enum Decision{
  Update = "5",
  Confirm  = "6",
  Cancel = "7"
}

enum ConfirmationMode {
  Success  = 1,
  Warning = 2,
  Error = 3
}
